/**
 * Step Tooltip Component
 * Tooltip showing current step message and actions
 */

import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ai-step-tooltip',
  templateUrl: './step-tooltip.component.html',
  styleUrls: ['./step-tooltip.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class StepTooltipComponent {

  @Input() message: string = '';
  @Input() eyebrow?: string;
  @Input() title?: string;
  @Input() position: 'top' | 'bottom' | 'left' | 'right' = 'bottom';
  @Input() showNext: boolean = true;
  @Input() showSkip: boolean = true;
  @Input() canGoBack: boolean = false;
  @Input() mediaUrl?: string;

  @Output() next = new EventEmitter<void>();
  @Output() skip = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();

  /**
   * Handle next button click
   */
  onNext(): void {
    this.next.emit();
  }

  onBack(): void {
    this.back.emit();
  }

  /**
   * Handle skip button click
   */
  onSkip(): void {
    this.skip.emit();
  }

  /**
   * Get arrow class based on position
   */
  get arrowClass(): string {
    return `arrow-${this.position}`;
  }
}
